import {makeStyles} from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
	root: {

	},
	loginButton: {
		marginRight: theme.spacing(2),
	}
}));
